import { toFirstLetterUppercase } from '@silverfort-nodelibs/common/utils/common';
import { RISK_LEVELS } from '@silverfort-nodelibs/common/utils/consts';
import { RISK_INDICATORS } from '@silverfort-nodelibs/common/utils/insight';

export const RISK_INDICATORS_OPTIONS = Object.keys(RISK_INDICATORS).map((indicatorKey) => ({
    value: indicatorKey,
    title:
        RISK_INDICATORS[indicatorKey].insightsTitle ||
        RISK_INDICATORS[indicatorKey].authTitle ||
        toFirstLetterUppercase(indicatorKey.replaceAll('_', ' ').toLowerCase())
}));

export const RISK_LEVELS_OPTIONS = Object.values(RISK_LEVELS).map((risk) => {
    return { title: toFirstLetterUppercase(risk.label), value: risk.value };
});
